import { useLocation } from "react-router-dom";

/**
 * Central route → { title, subtitle } map for the shared AppShell header.
 * Edit this file to change any page title; no page file needs to change.
 */
const ROUTE_META = [
  { re: /^\/dashboard$/, title: "Dashboard", subtitle: "Your daily overview" },
  { re: /^\/leads$/, title: "My Leads", subtitle: "Manage and track your leads" },
  { re: /^\/leads\/add$/, title: "New Lead", subtitle: "Add a new dealership" },
  { re: /^\/leads\/\d+\/edit$/, title: "Edit Lead", subtitle: "Update lead details" },
  { re: /^\/leads\/\d+\/demo$/, title: "Book Demo", subtitle: "Schedule a product demo" },
  { re: /^\/leads\/\d+$/, title: "Lead Details", subtitle: "" },
  { re: /^\/profile$/, title: "My Profile", subtitle: "Manage your account and preferences" },
  { re: /^\/developer$/, title: "Developer Portal", subtitle: "API and webhook reference" },
  { re: /^\/notifications$/, title: "Notifications", subtitle: "Reminders and system messages" },
  { re: /^\/analytics$/, title: "Analytics", subtitle: "Rep, source, and reminder performance" },
  { re: /^\/reports$/, title: "Reports", subtitle: "Build, download, email, or schedule reports" },
  { re: /^\/admin\//, title: "Administration", subtitle: "Manage users, master data, and integrations" },
  { re: /^\/welcome-pending$/, title: "Welcome", subtitle: "Your account is pending approval" },
];

export default function usePageMeta() {
  const { pathname } = useLocation();
  for (const entry of ROUTE_META) {
    if (entry.re.test(pathname)) {
      return { title: entry.title, subtitle: entry.subtitle };
    }
  }
  return { title: "", subtitle: "" };
}